import React from 'react';

import BaseBiointelligentLinkFieldModal, {
  BiointelligentLinkFieldModalProps,
} from './BaseBiointelligentLinkFieldModal';

export const PART_LINK_NUM_LONGEST_COMPONENTS_TEMPLATE_ID = 'svdrltmpl_autofilllongestnucleotideparts';
export const PART_LINK_MAX_LENGTH_TEMPLATE_ID = 'svdrltmpl_autofillmaxnucleotidepartlength';
export const PART_LINK_MIN_LENGTH_TEMPLATE_ID = 'svdrltmpl_autofillminnucleotidepartlength';
export const PART_LINK_DISABLE_OVERLAPPING_TEMPLATE_ID =
  'svdrltmpl_autofilldisableoverlappingnucleotideparts';

export default function PartLinkFieldModal({
  schemaField,
  onRequestSubmit,
  onRequestClose,
  enableMultiSelectOption,
}: BiointelligentLinkFieldModalProps): JSX.Element {
  return (
    <BaseBiointelligentLinkFieldModal
      schemaField={schemaField}
      componentName="parts"
      residueName="base"
      numLongestComponentsTemplateId={PART_LINK_NUM_LONGEST_COMPONENTS_TEMPLATE_ID}
      maxLengthTemplateId={PART_LINK_MAX_LENGTH_TEMPLATE_ID}
      minLengthTemplateId={PART_LINK_MIN_LENGTH_TEMPLATE_ID}
      disableOverlappingTemplateId={PART_LINK_DISABLE_OVERLAPPING_TEMPLATE_ID}
      onRequestSubmit={onRequestSubmit}
      onRequestClose={onRequestClose}
      enableMultiSelectOption={enableMultiSelectOption}
    />
  );
}
